var DEFAULT_HTML_FONTSIZE = 10;
var white = '#ffffff';
var black = '#000000';
var textPrimary = '#040404';
var textSecondary = '#545454';
var textDisabled = '#33333361';
var pageBackgroundMain = '#f5f8fa';
var FONT_WEIGHT_LIGHT = 300;
var FONT_WEIGHT_REGULAR = 400;
var FONT_WEIGHT_BOLD = 700;

var palette = {
  primary: {
    light: '#56a5cb',
    main: '#007DAA',
    dark: '#004A6C'
  },
  secondary: {
    light: '#EDEBFF',
    main: '#7357FF',
    dark: '#551CD9'
  },
  error: {
    light: '#F88078',
    main: '#F44336',
    dark: '#E31B0C'
  },
  info: {
    light: '#64B6F7',
    main: '#2196f3',
    dark: '#0A6BB8'
  },
  warning: {
    light: '#FFB547',
    main: '#ED6C02',
    dark: '#C77700'
  },
  success: {
    light: '#88af4a',
    main: '#587f1b',
    dark: '#2a5200'
  },
  text: {
    primary: textPrimary,
    secondary: textSecondary,
    disabled: textDisabled
  },
  pageBackground: {
    light: white,
    main: pageBackgroundMain,
    secondary: '#E9E5F0'
  },
  secondaryPageBackground: {
    main: '#E9E5F0' // we should phase this out in favor of pageBackground.secondary
  },

  listScore: {
    A: '#71D98E',
    B: '#C8E034',
    C: '#FFE065',
    D: '#FFB547',
    F: '#F88078'
  },
  reach: {
    light: '#ED99FB26',
    main: '#ED99FB',
    dark: '#7C068F'
  },
  level: {
    light: '#FFE06526',
    main: '#FFE065',
    dark: '#655100'
  },
  likely: {
    light: '#78DEFF26',
    main: '#78DEFF',
    dark: '#005B78'
  }
};

var pxToRems = function pxToRems() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var htmlFontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_HTML_FONTSIZE;
  var coef = 14 / 14;
  return "".concat(size / htmlFontSize * coef, "rem");
};

var DISABLED_STYLE = {
  '&$disabled': {
    color: 'none',
    boxShadow: 'none',
    backgroundColor: 'none',
    opacity: 0.3
  }
};
var getOverrides = function getOverrides(htmlFontSize) {
  var LARGE_SIZE_BUTTON = {
    fontSize: pxToRems(15, htmlFontSize),
    lineHeight: '24px',
    borderRadius: '40px'
  };
  var MEDIUM_SIZE_BUTTON = {
    fontSize: pxToRems(14, htmlFontSize),
    lineHeight: '24px',
    borderRadius: '36px'
  };
  var SMALL_SIZE_BUTTON = {
    fontSize: pxToRems(13, htmlFontSize),
    lineHeight: '22px',
    borderRadius: '32px'
  };
  return {
    MuiButtonBase: {
      root: {
        outline: '',
        WebkitTapHighlightColor: '',
        '-moz-appearance': '',
        '-webkit-appearance': '',
        '&::-moz-focus-inner': {
          borderStyle: ''
        }
      }
    },
    MuiListSubheader: {
      root: {
        color: textPrimary,
        fontFamily: "'Roboto Slab', serif",
        fontWeight: FONT_WEIGHT_REGULAR,
        letterSpacing: '0.1px',
        lineHeight: 1.25,
        paddingTop: '16px',
        paddingBottom: '16px',
        display: 'block'
      }
    },
    MuiButton: {
      root: Object.assign(Object.assign({
        fontFamily: '"Roboto","Open Sans"',
        textTransform: 'none',
        letterSpacing: '0.46px',
        padding: '6px 8px'
      }, MEDIUM_SIZE_BUTTON), DISABLED_STYLE),
      textSizeLarge: Object.assign(Object.assign({}, LARGE_SIZE_BUTTON), {
        padding: '8px 12px'
      }),
      textSizeSmall: Object.assign(Object.assign({}, SMALL_SIZE_BUTTON), {
        padding: '4px 5px'
      }),
      containedSizeLarge: Object.assign(Object.assign({}, LARGE_SIZE_BUTTON), {
        padding: '8px 24px'
      }),
      containedSizeSmall: Object.assign(Object.assign({}, SMALL_SIZE_BUTTON), {
        padding: '4px 10px'
      }),
      outlinedSizeLarge: Object.assign(Object.assign({}, LARGE_SIZE_BUTTON), {
        padding: '8px 24px'
      }),
      outlinedSizeSmall: Object.assign(Object.assign({}, SMALL_SIZE_BUTTON), {
        padding: '4px 10px'
      }),
      contained: Object.assign({
        boxShadow: 'none',
        padding: '6px 16px',
        '&:hover, &:active, &.Mui-focusVisible': {
          boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)'
        }
      }, DISABLED_STYLE),
      outlined: Object.assign({
        boxShadow: 'none',
        padding: '6px 16px'
      }, DISABLED_STYLE),
      containedPrimary: {
        '&:hover': {
          color: white
        }
      },
      containedSecondary: {
        '&:hover': {
          color: white
        }
      },
      startIcon: {
        marginLeft: 0,
        marginTop: '-2px',
        '&$iconSizeSmall': {
          marginLeft: 0
        }
      },
      endIcon: {
        marginRight: 0,
        marginTop: '-2px',
        '&$iconSizeSmall': {
          marginRight: 0
        }
      },
      iconSizeLarge: {
        height: '1em',
        width: '1em',
        fontSize: '20px'
      },
      iconSizeMedium: {
        height: '1em',
        width: '1em',
        fontSize: '18px'
      }
    },
    MuiAvatar: {
      colorDefault: {
        color: white,
        backgroundColor: textSecondary
      }
    },
    MuiListItem: {
      root: {
        '&.MuiListItem-button.Mui-selected': {
          backgroundColor: pageBackgroundMain
        },
        '&.MuiListItem-button.Mui-selected:hover': {
          backgroundColor: pageBackgroundMain
        },
        '&.MuiListItem-button.Mui-selected:focus': {
          backgroundColor: pageBackgroundMain
        },
        '&.MuiListItem-button:hover': {
          textDecoration: 'none'
        },
        '&.MuiListItem-button:focus': {
          textDecoration: 'none'
        }
      }
    },
    MuiChip: {
      outlinedPrimary: {
        background: white
      },
      colorPrimary: {
        border: '1px solid #15769a'
      }
    },
    MuiTabs: {
      indicator: {
        height: '3px',
        backgroundColor: 'rgba(33, 150, 243, 0.5)'
      }
    },
    MuiTab: {
      textColorPrimary: {
        '&.Mui-selected': {
          color: black
        }
      }
    },
    // @ts-expect-error - MuiAlert is apart of labs
    MuiAlert: {
      root: {
        alignItems: 'center'
      }
    }
  };
};

var getTypography = function getTypography(htmlFontSize) {
  return {
    htmlFontSize: htmlFontSize,
    h1: {
      fontSize: pxToRems(96, htmlFontSize),
      fontWeight: FONT_WEIGHT_LIGHT,
      letterSpacing: '-1.5px',
      lineHeight: '112px'
    },
    h2: {
      fontSize: pxToRems(60, htmlFontSize),
      fontWeight: FONT_WEIGHT_LIGHT,
      letterSpacing: '-0.5px',
      lineHeight: 1.2
    },
    h3: {
      fontFamily: "'Roboto Slab', serif",
      fontSize: pxToRems(44, htmlFontSize),
      fontWeight: FONT_WEIGHT_BOLD,
      letterSpacing: 0,
      lineHeight: 1.2
    },
    h4: {
      fontFamily: "'Roboto Slab', serif",
      fontSize: pxToRems(32, htmlFontSize),
      fontWeight: FONT_WEIGHT_BOLD,
      lineHeight: 1.235
    },
    h5: {
      fontSize: pxToRems(24, htmlFontSize),
      fontWeight: FONT_WEIGHT_REGULAR,
      lineHeight: 1.2
    },
    h6: {
      fontFamily: "'Roboto Slab', serif",
      fontSize: pxToRems(20, htmlFontSize),
      fontWeight: FONT_WEIGHT_REGULAR,
      letterSpacing: '0.15px',
      lineHeight: 1.6
    },
    subtitle1: {
      fontSize: pxToRems(16, htmlFontSize),
      fontWeight: FONT_WEIGHT_REGULAR,
      letterSpacing: '0.15px',
      lineHeight: '28px'
    },
    subtitle2: {
      fontFamily: "'Roboto Slab', serif",
      fontSize: pxToRems(14, htmlFontSize),
      fontWeight: FONT_WEIGHT_REGULAR,
      letterSpacing: '0.1px',
      lineHeight: '17.5px'
    },
    body1: {
      fontSize: pxToRems(16, htmlFontSize),
      fontWeight: FONT_WEIGHT_REGULAR,
      letterSpacing: '0.15px',
      lineHeight: '24px'
    },
    body2: {
      fontSize: pxToRems(14, htmlFontSize),
      fontWeight: FONT_WEIGHT_REGULAR,
      letterSpacing: '0.15px',
      lineHeight: '20px'
    },
    button: {
      textTransform: 'none'
    },
    fontFamily: ['Roboto', '"Open Sans"', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(',')
  };
};

var createMuiFromHTMLFontSize = function createMuiFromHTMLFontSize(htmlFontSize) {
  return {
    props: {
      MuiButtonBase: {
        disableRipple: true
      },
      MuiButton: {
        disableRipple: true
      },
      MuiCard: {
        elevation: 2
      },
      MuiCheckbox: {
        disableRipple: false
      },
      MuiRadio: {
        disableRipple: false
      },
      MuiSwitch: {
        disableRipple: false
      }
    },
    palette: palette,
    overrides: getOverrides(htmlFontSize),
    typography: getTypography(htmlFontSize)
  };
};
var DEFAULT_THEME_CONFIG = createMuiFromHTMLFontSize(DEFAULT_HTML_FONTSIZE);

export { DEFAULT_THEME_CONFIG, createMuiFromHTMLFontSize, palette };
//# sourceMappingURL=mui-theme.module.js.map
